import { render, staticRenderFns } from "./AlterarDataAgendamentoChat.vue?vue&type=template&id=fc0363d6&scoped=true"
import script from "./AlterarDataAgendamentoChat.vue?vue&type=script&lang=ts"
export * from "./AlterarDataAgendamentoChat.vue?vue&type=script&lang=ts"
import style0 from "./AlterarDataAgendamentoChat.vue?vue&type=style&index=0&id=fc0363d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0363d6",
  null
  
)

export default component.exports